import * as types from '../actions/actionTypes';

import {getStartDate, formatDateForInput} from '../../lib/utils';

let initialState = {
    fundDetails: {
        loading: false,
        success: true,
        data: {}
    },
    updateFund: {
        loading: false,
        success: true
    },
    transactionsFilters: {
        startDate: formatDateForInput(getStartDate()),
        endDate: formatDateForInput(new Date()),
        search: ''
    },
    outsideTransactionsFilters: {
        startDate: formatDateForInput(getStartDate()),
        endDate: formatDateForInput(new Date()),
        search: ''
    },
    newOutsideTransaction: {
        loading: false,
        success: true
    },
    updateTransaction: {
        loading: false,
        success: true
    },
    blankChecks: {
        loading: false,
        success: true,
        data: []
    },
    voidTransactions: {
        loading: false,
        success: true
    }
};

export default function recipientAccountDetailsReducer(state = initialState, action) {
    switch (action.type) {

        case types.START_GET_FUND_DETAILS:
            return {...state, fundDetails: {...initialState.fundDetails, loading: true}};
        case types.GET_FUND_DETAILS:
            return {...state, fundDetails: {...state.fundDetails, ...action.response}};

        case types.START_UPDATE_FUND:
            return {...state, updateFund: {...initialState.update, loading: true}};
        case types.UPDATE_FUND:
            return {
                ...state,
                updateFund: {...state.updateFund, ...action.response},
                fundDetails: {
                    ...state.fundDetails,
                    data: action.response.success ? action.response.data : state.fundDetails.data
                }
            };

        case types.UPDATE_ACCOUNTING_FILTERS:
            return Object.assign({}, state, {transactionsFilters: {...state.transactionsFilters, ...action.update}});

        case types.UPDATE_ACCOUNTING_OUTSIDE_TRANSACTION_FILTERS:
            return Object.assign({}, state, {outsideTransactionsFilters: {...state.outsideTransactionsFilters, ...action.update}});

        case types.START_CREATE_OUTSIDE_TRANSACTION:
            return {...state, newOutsideTransaction: {...initialState.newOutsideTransaction, loading: true}};
        case types.CREATE_OUTSIDE_TRANSACTION:
            return {...state, newOutsideTransaction: {...action.response}};
        case types.START_UPDATE_TRANSACTION:
            return {...state, updateTransaction: {...initialState.updateTransaction, loading: true}};
        case types.UPDATE_TRANSACTION:
            return {...state, updateTransaction: {...action.response}};
        case types.START_VOIDING_TRANSACTION:
            return {...state, voidTransactions: {...initialState.voidTransactions, loading: true}};
        case types.VOID_TRANSACTIONS:
            return {...state, voidTransactions: {...action.response}};

        case types.START_GET_BLANK_CHECKS:
            return {...state, blankChecks: {...initialState.blankChecks, loading: true}};
        case types.GET_BLANK_CHECKS:
            return {...state, blankChecks: {...initialState.blankChecks, ...action.response}};
        case types.CLEAR_BLANK_CHECKS:
            return {...state, blankChecks: initialState.blankChecks};

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/FundDetailsReducer.js